var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import clsx from "clsx";
import { Category } from "../Category";
import { getMemberExtraClassNames } from "../../../helpers/getMemberExtraClassNames";
export var Row = function (_a) {
    var children = _a.children, includeSeparator = _a.includeSeparator, collapsible = _a.collapsible, useAltColors = _a.useAltColors, leadingImage = _a.leadingImage, leadingImageOptions = _a.leadingImageOptions, isRebrandedNavigation = _a.isRebrandedNavigation;
    // TO-DO remove !isRebrandedNavigation variants when all countries have the rebranded navigation
    var _b = useState(null), currentCategory = _b[0], setCurrrentCategory = _b[1];
    var hasCollapsableChildren = collapsible;
    var hasOneChild = children.length === 1;
    var baseClass = "mb-12 last:mb-0 last:pb-10 md:last:pb-16";
    var conditionalClass = {
        "text-center": hasOneChild,
        "bg-primary-300 text-white bg-no-repeat bg-cover bg-center alt-color-row pt-5 md:pt-1": useAltColors,
        "md:pl-30 lg:pl-50": !useAltColors && isRebrandedNavigation,
    };
    return (React.createElement("div", { className: clsx(baseClass, conditionalClass) },
        leadingImage && (React.createElement("img", { src: leadingImage.url, alt: leadingImage.alt, className: clsx("absolute left-5", getMemberExtraClassNames(leadingImageOptions)) })),
        React.createElement("div", { className: clsx("relative md:mx-auto", {
                "md:max-w-[996px]": !useAltColors && isRebrandedNavigation,
                "md:max-w-[1112px]": useAltColors && isRebrandedNavigation,
                "md:grid grid-cols-4": isRebrandedNavigation,
                "md:mx-auto md:max-w-screen-lg md:grid grid-cols-5": !isRebrandedNavigation,
            }) },
            includeSeparator && React.createElement("hr", { className: "md:hidden mx-4 border-t border-gray-100 -mb-4" }),
            children.map(function (category, index) { return (React.createElement(Category, __assign({}, category, { key: index, index: index, isCollapsable: hasCollapsableChildren, isOnlyChild: hasOneChild, currentCategory: currentCategory, setCurrentCategory: setCurrrentCategory, useAltColors: useAltColors }))); }))));
};
//# sourceMappingURL=Row.js.map